import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function ProcessSection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      label: 'HOW IT WORKS',
      headline: 'Your Masterpiece In 3 Steps',
      steps: [{
        num: '01',
        title: 'Tell Me Your Story',
        text: 'We connect via WhatsApp or Instagram DM. You share your idea, your vision, your story. I listen before I draw.'
      }, {
        num: '02',
        title: 'Custom Design',
        text: 'I create a design made exclusively for you. No templates. No copies. Only original art.'
      }, {
        num: '03',
        title: 'Eternal Art',
        text: 'Your story becomes a permanent masterpiece. Fine art. On your skin. Forever.'
      }]
    },
    es: {
      label: 'CÓMO FUNCIONA',
      headline: 'Tu Obra Maestra En 3 Pasos',
      steps: [{
        num: '01',
        title: 'Cuéntame Tu Historia',
        text: 'Nos conectamos por WhatsApp o Instagram. Compartes tu idea, tu visión, tu historia. Escucho antes de dibujar.'
      }, {
        num: '02',
        title: 'Diseño Personalizado',
        text: 'Creo un diseño hecho exclusivamente para ti. Sin plantillas. Sin copias. Solo arte original.'
      }, {
        num: '03',
        title: 'Arte Eterno',
        text: 'Tu historia se convierte en una obra maestra permanente. Fine art. En tu piel. Para siempre.'
      }]
    }
  };
  const t = content[language];
  return <section className="bg-brand-charcoal py-24 md:py-32 px-6 border-b border-brand-gold/30" data-id="element-146">
      <div className="max-w-7xl mx-auto" data-id="element-147">
        <motion.div className="mb-20 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-148">
          <span className="text-brand-gold font-sans text-sm tracking-[0.3em] uppercase block mb-4" data-id="element-149">
            {t.label}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-gold" data-id="element-150">
            {t.headline}
          </h2>
        </motion.div>

        <div className="relative" data-id="element-151">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] border-t border-dashed border-brand-gold/50" data-id="element-152" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-153">
            {t.steps.map((step, index) => <motion.div key={index} className="relative flex flex-col items-center text-center" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} data-id="element-154">
                <div className="w-24 h-24 rounded-full bg-brand-black border-2 border-brand-gold flex items-center justify-center mb-8 relative z-10 shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-155">
                  <span className="text-3xl font-serif text-brand-gold" data-id="element-156">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-brand-gold mb-4" data-id="element-157">
                  {step.title}
                </h3>
                <p className="text-brand-white/80 font-sans font-light leading-relaxed max-w-sm" data-id="element-158">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}